import React from 'react';
import { string } from 'prop-types';

import * as helpers from './helpers';

const ProjectsIcon = ({ color, ...props }) => (
  <svg {...helpers.getSvgDimensionsProps(props)} {...props}>
    <path
      fill={color}
      fillRule="evenodd"
      d="M3.984 14.4a.374.374 0 0 1-.264-.096.352.352 0 0 1-.104-.272v-1.12c-.747-.064-1.39-.237-1.928-.52-.539-.283-.95-.635-1.232-1.056A2.597 2.597 0 0 1 0 9.984c0-.085.032-.16.096-.224a.326.326 0 0 1 .24-.096h.768c.203 0 .341.107.416.32.096.448.37.835.824 1.16.453.325 1.101.488 1.944.488.907 0 1.584-.16 2.032-.48.448-.32.672-.763.672-1.328 0-.363-.11-.661-.328-.896-.219-.235-.544-.44-.976-.616-.432-.176-1.08-.392-1.944-.648-.821-.235-1.477-.485-1.968-.752-.49-.267-.859-.595-1.104-.984-.245-.39-.368-.883-.368-1.48 0-.8.293-1.472.88-2.016s1.397-.864 2.432-.96V.368c0-.117.035-.208.104-.272A.374.374 0 0 1 3.984 0h.576c.107 0 .192.035.256.104.064.07.096.157.096.264v1.12c.683.085 1.27.277 1.76.576.49.299.861.648 1.112 1.048.25.4.387.803.408 1.208a.326.326 0 0 1-.336.336h-.8a.441.441 0 0 1-.248-.08.359.359 0 0 1-.152-.24c-.064-.459-.32-.837-.768-1.136-.448-.299-1.008-.448-1.68-.448-.725 0-1.301.141-1.728.424-.427.283-.64.701-.64 1.256 0 .373.099.677.296.912.197.235.501.443.912.624.41.181 1.005.39 1.784.624.907.256 1.621.512 2.144.768.523.256.912.573 1.168.952.256.379.384.867.384 1.464 0 .907-.323 1.637-.968 2.192-.645.555-1.528.875-2.648.96v1.104a.374.374 0 0 1-.096.264.332.332 0 0 1-.256.104h-.576z"
    />
  </svg>
);

ProjectsIcon.propTypes = {
  color: string.isRequired,
  ...helpers.iconDimensionsPropTypes,
};

ProjectsIcon.defaultProps = {
  ...helpers.getDefaultIconDimensionsProps(9, 15),
};

export default ProjectsIcon;



// WEBPACK FOOTER //
// ./src/components/svg-icon/icons/projects.js